<template>
	<div v-if="data" class="sub-values inline">
		<div class="sub-value clickable" @click="$emit('click')">
			<div class="label">{{ data.min }} - {{ data.max }} Monate</div>
		</div>
	</div>
</template>

<script>
export default {
	props: {
		data: {
			type: Object,
			required: false
		}
	},
}
</script>
